export const NAV_LINKS = [
    { label: 'Accueil', path: '/' },
    { label: 'À propos', path: '/a-propos' },
    { label: 'Projets', path: '/mes-projet' },
    { label: 'Contact', path: '/contact' },
  ];